module.exports = __webpack_public_path__ + "media/images/strategy-managing-risk-95f8f287e97455912d84f91aedd57244.png";